import { Check } from 'lucide-react';
import { FC, ReactNode } from 'react';

import {
	PunchupDialogue,
	DialogIcon,
	DialogTitle,
	DEFAULT_MAX_WIDTH,
} from 'features/common/components/Punchup/composites/dialogs/PunchupDialogue';

// Re-exported from PunchupDialogue for backwards compatibility.
export { ButtonGroup } from 'features/common/components/Punchup/composites/dialogs/PunchupDialogue';

/** Wide-picker width, as per the PunchupDialogue `maxWidth` prop doc. */
const WIDE_WIDTH = 900;

export interface PunchupModalProps {
	children: ReactNode;
	title: string;
	wide?: boolean;
}

export const PunchupModal: FC<PunchupModalProps> = ({ children, title, wide = false }) => (
	<PunchupDialogue maxWidth={wide ? WIDE_WIDTH : DEFAULT_MAX_WIDTH}>
		<DialogIcon>
			<Check />
		</DialogIcon>
		<DialogTitle>{title}</DialogTitle>
		{children}
	</PunchupDialogue>
);
